import { AppUserService } from '@ceres/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { IUser, rolePermissions } from '@ceres/domain';
import { Observable } from 'rxjs';
import { FeatureOf, FEATURES } from '@ceres/feature-toggles';
import { CeresFeaturesConfig } from '@ceres/shared/features';
import { TasksService } from '../services/tasks.service';
import { LoadingService } from '../services/loading.service';
import { ThemeService } from '../services/theme.service';
import { SearchComponent } from './search/search.component';
import { AuthService } from '../../auth/services/auth.service';

@Component({
    selector: 'ceres-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit {
    readonly features = inject<FeatureOf<CeresFeaturesConfig>>(FEATURES);
    private loadingService = inject(LoadingService);
    private translateService = inject(TranslateService);
    appUserService = inject(AppUserService);
    private authService = inject(AuthService);
    private tasksService = inject(TasksService);
    private themeService = inject(ThemeService);

    public isNavigationPartlyOpen = false;
    public isNavigationOpen = false;
    public isUserMenuPartlyOpen = false;
    public isUserMenuOpen = false;
    public isSearchOpen = false;
    public currentUser: IUser;
    public permission = rolePermissions;
    isLoading = false;
    impersonatedEmployee$: Observable<IUser>;
    openTasksCount = 0;

    @ViewChild(SearchComponent) searchComp: SearchComponent;
    public checked = false;

    changeTheme() {
        this.checked = !this.checked;
        if (this.checked) {
            this.themeService.setDarkMode();
        } else {
            this.themeService.setLightMode();
        }
    }

    ngOnInit() {
        this.themeService.darkMode$.subscribe((darkMode) => {
            this.checked = darkMode;
        });

        this.appUserService.loggedInUser$.asObservable().subscribe((user) => {
            this.currentUser = user;
        });

        this.loadingService.state.subscribe((newState) => {
            this.isLoading = newState;
        });

        this.tasksService.tasks.subscribe((tasks) => {
            if (tasks) {
                this.openTasksCount = tasks.filter((t) => t.status === 'open').length;
            }
        });
        this.impersonatedEmployee$ = this.appUserService.impersonatedEmployee$.asObservable();
    }

    public check() {
        this.isSearchOpen = false;
    }
    public openSearch() {
        this.isSearchOpen = true;
        this.searchComp.focus();
    }

    public changeLanguage(): void {
        this.translateService.use(this.translateService.getCurrentLang() === 'en' ? 'de' : 'en');
    }

    public logout() {
        this.authService.logout();
    }
}
